import { useEffect, useState } from 'react'
import './navigation.css'

/**
 * Sticky horizontal nav that jumps between on-page sections and highlights the active one.
 * @param {{ id: string, label: string }[]} sections
 */
export function SectionNav({ sections = [] }) {
  const [activeId, setActiveId] = useState(sections[0]?.id)

  useEffect(() => {
    if (!sections.length) return

    const visible = new Map()

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          visible.set(entry.target.id, entry.isIntersecting ? entry.intersectionRatio : 0)
        })

        const visibleSections = sections.filter((s) => visible.get(s.id) > 0)
        if (visibleSections.length) {
          const best = visibleSections.reduce((a, b) =>
            (visible.get(a.id) || 0) >= (visible.get(b.id) || 0) ? a : b
          )
          setActiveId(best.id)
        }
      },
      { rootMargin: '-20% 0px -55% 0px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    )

    sections.forEach(({ id }) => {
      const el = document.getElementById(id)
      if (el) observer.observe(el)
    })

    return () => observer.disconnect()
  }, [sections])

  if (sections.length < 2) return null

  const scrollTo = (e, id) => {
    e.preventDefault()
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      setActiveId(id)
    }
  }

  return (
    <div className="section-nav-wrap">
      <nav className="section-nav" aria-label="Sektioner på siden">
        {sections.map(({ id, label }) => (
          <a
            key={id}
            href={'#' + id}
            className={activeId === id ? 'active' : ''}
            onClick={(e) => scrollTo(e, id)}
          >
            {label}
          </a>
        ))}
      </nav>
    </div>
  )
}
